import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//FIREBASE
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { firebaseConfig } from 'src/environments/environment';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
//import { Clipboard } from '@ionic-native/clipboard/ngx';
import { SwiperModule } from "swiper/angular";

import { AngularFireFunctionsModule,} from '@angular/fire/compat/functions';

import localePy from '@angular/common/locales/es-CO';
import { registerLocaleData } from '@angular/common';
import { CedulaModalComponent } from './components/cedula-modal/cedula-modal.component';
import { ActualizarUbicacionComponent } from './components/actualizar-ubicacion/actualizar-ubicacion.component';
registerLocaleData(localePy, 'es')

@NgModule({
  declarations: [AppComponent, CedulaModalComponent,ActualizarUbicacionComponent ],
  entryComponents: [ ],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    SwiperModule,
    IonicModule,
    
    
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es'},
    { provide: RouteReuseStrategy, 
      useClass: IonicRouteStrategy,}
  ],
  bootstrap: [AppComponent],
  exports:[CedulaModalComponent,ActualizarUbicacionComponent ]
})
export class AppModule {}
